import "../../../styles/Print.scss";
import { useSelector } from "react-redux";
import { getPayablesFinancialCard, selectState } from "../accountPayable.slice";
import React, { useEffect } from "react";
import { useMemorandumLogo } from "hooks/MemorandumLogo";
import { useAppDispatch } from "hooks/hooks";
import { FormatDateShort } from "utils/dateUtils";
import { FormatNumber, FormatNumberOrNull } from "utils/numberUtils";

interface IProps {
  doPrint: Function;
}
const PrintPayablesFinancialCard = ({ doPrint }: IProps) => {
  const dispatch = useAppDispatch();

  const { payablesFinancialCard } = useSelector(selectState);
  const memorandumLogo = useMemorandumLogo();

  useEffect(() => {
    dispatch(getPayablesFinancialCard(3));
  }, []);


  useEffect(() => {
    doPrint(payablesFinancialCard);
  }, [doPrint, payablesFinancialCard]);

  return (
    <section className="payablesFinancialCard">
      <div className="logo">
        {memorandumLogo && <img src={memorandumLogo} alt="" />}
      </div>
      <div className="header">
        <div>Finansijska kartica:</div>
        <div className="small">{payablesFinancialCard && FormatDateShort(payablesFinancialCard.date)}</div>
      </div>
      <div className="financial-card-partner-info">
        <div className="strong left">{payablesFinancialCard?.partnerName}</div>
        <div className="small">{payablesFinancialCard?.bankAccountNumber}</div>
      </div>
      <table className="financial-card-table financial-card-table-header">
        <tbody>
          <tr>
            <th>faktura</th>
            <th>projekat</th>
            <th>datum</th>
            <th>za isplatu</th>
            <th></th>
            <th></th>
            <th>dug</th>
            <th>isplaćeno</th>
          </tr>
        </tbody>
      </table>
      <table className="financial-card-table financial-card-table-body">
        <tbody>
          {payablesFinancialCard?.items.map((item, index) => (
            <React.Fragment key={index}>
              <tr>
                <td className="center">{item.invoiceId}</td>
                <td>{item.projectName}</td>
                <td>{FormatDateShort(item.invoiceDate)}</td>
                <td>{FormatNumber(item.amountInvoiced)}</td>
                <td></td>
                <td>{item.isXxx && (<input type="checkbox" checked readOnly />)}</td>
                <td>{FormatNumber(item.amountOutstanding)}</td>
                <td>{FormatNumber(item.amountPaid)}</td>
              </tr>

              {item.payments.map((payment, paymentIndex) => {
                return (
                  <tr className="financial-card-payment-row" key={paymentIndex}>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{payment.isCash && (<input type="checkbox" checked readOnly />)}</td>
                    <td></td>
                    <td>{FormatDateShort(payment.paymentDate)}</td>
                    <td>{FormatNumber(payment.amount)}</td>
                  </tr>);
              })}
            </React.Fragment>
          ))}
        </tbody>
        <tfoot className="financial-card-table-footer">
          <tr>
            <td></td>
            <td></td>
            <td>Ukupno:</td>
            <td><div className="border">{FormatNumberOrNull(payablesFinancialCard?.payablesTotalInvoicedAmountForPartner)}</div></td>
            <td></td>
            <td></td>
            <td><div className="border">{FormatNumberOrNull(payablesFinancialCard?.payablesTotalOutstandingAmountForPartner)}</div></td>
            <td><div className="border">{FormatNumberOrNull(payablesFinancialCard?.payablesTotalPaidAmountForPartner)}</div></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>Ukupno xxx:</td>
            <td><div className="border">{FormatNumberOrNull(payablesFinancialCard?.payablesTotalXxxInvoicedAmountForPartner)}</div></td>
            <td></td>
            <td></td>
            <td><div className="border">{FormatNumberOrNull(payablesFinancialCard?.payablesTotalXxxOutstandingAmountForPartner)}</div></td>
            <td><div className="border">{FormatNumberOrNull(payablesFinancialCard?.payablesTotalXxxPaidAmountForPartner)}</div></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>Ukupno keš:</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td><div className="border">{FormatNumberOrNull(payablesFinancialCard?.payablesTotalCashPaidAmountForPartner)}</div></td>
          </tr>
        </tfoot>
      </table>
    </section>
  );
};

export default PrintPayablesFinancialCard;
